webpackJsonp([0],{

/***/ "/481":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'download',
  data: function data() {
    return {
      seen: false,
      version: '',
      downloadUrls: {}
    };
  },

  methods: {
    expandLinks: function expandLinks() {
      this.seen = true;
    }
  }
});

/***/ }),

/***/ "/COB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/IOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'course',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3bwd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5CNu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "61ED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_vue__ = __webpack_require__("/IOm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca1c958_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_vue__ = __webpack_require__("enFX");
function injectStyle (ssrContext) {
  __webpack_require__("6U3X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ca1c958"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca1c958_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6U3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8aqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gymnasiumDetail_vue__ = __webpack_require__("uucU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3499b1e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gymnasiumDetail_vue__ = __webpack_require__("lXEb");
function injectStyle (ssrContext) {
  __webpack_require__("aJe3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3499b1e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gymnasiumDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3499b1e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gymnasiumDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AVWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_message_vue__ = __webpack_require__("ngeQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4255d7c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_message_vue__ = __webpack_require__("Y/FV");
function injectStyle (ssrContext) {
  __webpack_require__("NfcG")
  __webpack_require__("Nhso")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4255d7c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_message_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4255d7c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BbX9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DHg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "competition",
  data: function data() {
    return {
      imgUrl: ''
    };
  },

  mounted: function mounted() {
    console.log(this.$route.query.subject);
    this.imgUrl = "/static/subject" + this.$route.query.subject + ".png";
    // var navDiv = document.getElementById("nav-1");
    // var mt = navDiv.offsetTop;
    // console.log(mt)
    // window.onscroll = function() {
    //   var t = document.documentElement.scrollTop || document.body.scrollTop;
    //   // console.log(t)
    //   if (t > mt) {
    //     navDiv.style.position = "fixed";
    //     navDiv.style.top = "0";
    //   } else {
    //     navDiv.style.position = "relative";
    //   }
    // };
  }
});

/***/ }),

/***/ "DITj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DmJg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_download_vue__ = __webpack_require__("/481");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84405ace_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_vue__ = __webpack_require__("G76Y");
function injectStyle (ssrContext) {
  __webpack_require__("5CNu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84405ace"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_download_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84405ace_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      version: '',

      downloadUrls: {}
    };
  },

  methods: {}
});

/***/ }),

/***/ "G76Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content-section"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"margin":"1em 0","text-align":"center","font-size":"18px"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.expandLinks}},[_c('b',{staticStyle:{"color":"orange"}},[_vm._v("如果没能自动开始下载，请点击这里")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.seen)?_c('div',{staticClass:"row download-links mr-auto ml-auto",staticStyle:{"margin-top":"0","text-align":"center","padding":"0"}},[_c('div',{staticClass:"col-4"},[_c('a',{staticClass:"download",attrs:{"target":"_blank","href":_vm.getDownloadUrl(_vm.$route.params.source == "email" ? "email" : "windows")}},[_c('img',{attrs:{"src":"/static/windows.png"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.version))]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("Windows 7/8/10")])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('a',{staticClass:"download",attrs:{"target":"_blank","href":_vm.getDownloadUrl("linux")}},[_c('img',{attrs:{"src":"/static/ubuntu.png"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.version))]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("Ubuntu 12.04+")])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('a',{staticClass:"download",attrs:{"target":"_blank","href":_vm.getDownloadUrl("linux")}},[_c('img',{attrs:{"src":"/static/ubuntu.png"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.version))]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("Ubuntu 12.04+")])])])]):_vm._e()]),_vm._v(" "),_c('img',{staticStyle:{"border-radius":"16px","width":"100%","margin-top":"3em"},attrs:{"src":"/static/developers.jpg"}})],1),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title",staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("欢迎下载使用")]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("LogoUp 3D")]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("免费试用，")]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("也可通过软件帮助菜单购买续费功能微信购买专业版")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section",staticStyle:{"margin-top":"2em"}},[_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I+Sz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_competition_vue__ = __webpack_require__("nbJS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9748b11e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_competition_vue__ = __webpack_require__("QdwX");
function injectStyle (ssrContext) {
  __webpack_require__("pm3Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9748b11e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_competition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9748b11e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_competition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J1ck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subject1_vue__ = __webpack_require__("DHg0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52cd3262_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subject1_vue__ = __webpack_require__("c7O/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subject1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52cd3262_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subject1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LI+b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content-section"},[_c('div',[_vm._v("三维创新设计及其编程教育引领者")]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('p',[_vm._v("      "),_c('router-link',{staticClass:"foot-link",attrs:{"to":"/gymnasiumDetail?view=0"}},[_c('h3',[_vm._v(_vm._s(_vm.subject[0].title))])]),_vm._v(_vm._s(_vm.subject[0].centent)+" ")],1)]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('p',[_vm._v("     ")]),_c('h3',[_vm._v(_vm._s(_vm.subject[1].title))]),_vm._v(" "+_vm._s(_vm.subject[1].centent)+" "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('p',[_vm._v("      "),_c('router-link',{staticClass:"foot-link",attrs:{"to":"/gymnasiumDetail?view=1"}},[_c('h3',[_vm._v(_vm._s(_vm.subject[2].title))])]),_vm._v(" "+_vm._s(_vm.subject[2].centent))],1)])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section",staticStyle:{"margin-top":"2"}},[_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212c6ea9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("SDEW");
function injectStyle (ssrContext) {
  __webpack_require__("BbX9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212c6ea9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/*
 * @Author: ycm-windows hesion3d@hesion3d.com
 * @Date: 2021-04-15 18:24:37
 * @LastEditors: ycm-windows hesion3d@hesion3d.com
 * @LastEditTime: 2022-09-13 13:28:45
 * @FilePath: \logoup_portal\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  created: function created() {
    var _this = this;

    var protocol = location.protocol;
    console.log('protocol' + protocol);
    this.$http.get(protocol + '//hesion3d-prod.oss-cn-beijing.aliyuncs.com/logoup/install/latest.json').then(function (response) {
      var r = JSON.parse(response.bodyText);
      _this.$data.version = r.version;
      _this.$data.downloadUrls = r;
    }, function () {});
  },

  methods: {
    isChrome: function isChrome() {
      return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    },
    isSafari: function isSafari() {
      return navigator.userAgent.toLowerCase().indexOf('safari') > -1;
    },
    downloadFile: function downloadFile(sUrl) {
      // iOS devices do not support downloading. We have to inform user about this.
      var protocol = location.protocol;
      if (protocol === 'https:' && sUrl.indexOf('http:') === 0) {
        sUrl = sUrl.replace('http:', 'https:');
      }

      if (/(iP)/g.test(navigator.userAgent)) {
        return false;
      }
      // If in Chrome or Safari - download via virtual link click
      if (this.isChrome() || this.isSafari()) {
        // Creating new link node.
        var link = document.createElement('a');
        link.href = sUrl;
        if (link.download !== undefined) {
          // Set HTML5 download attribute. This will prevent file from opening if supported.
          var fileName = sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length);
          link.download = fileName;
        }
        // Dispatching click event.
        if (document.createEvent) {
          var e = document.createEvent('MouseEvents');
          e.initEvent('click', true, true);
          link.dispatchEvent(e);
          return true;
        }
      }
      // Force file download (whether supported by server).
      var t = sUrl;
      if (t.indexOf('?') === -1) {
        t += '?download';
      }
      // 如果 location.protocol 是 https，如果t前面是 http：，则修改t为https：

      window.open(t, '_self');
      return true;
    },
    download: function download(platform) {
      debugger;
      if (this.downloadUrls) {
        this.downloadFile(this.getDownloadUrl(platform));
      }
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: '/download' });
    },
    getDownloadUrl: function getDownloadUrl(platform) {
      var downloadUrl = '';
      if (this.downloadUrls) {
        if (platform === 'mac') {
          downloadUrl = this.downloadUrls.download_url_macos;
        } else if (platform === 'linux') {
          downloadUrl = this.downloadUrls.download_url_linux;
        } else if (platform === 'macIntel') {
          downloadUrl = this.downloadUrls.download_url_macos_x64;
        } else if (platform === 'macArm64') {
          downloadUrl = this.downloadUrls.download_url_macos_arm64;
        } else if (platform === 'windows') {
          downloadUrl = this.downloadUrls.download_url_window;
        }if (platform === 'kirinArm') {
          downloadUrl = this.downloadUrls.download_url_kirinArm;
        }if (platform === 'kirinLoongArch') {
          downloadUrl = this.downloadUrls.download_url_kirinLoongArch;
        }if (platform === 'uosArm') {
          downloadUrl = this.downloadUrls.download_url_uosArm;
        }if (platform === 'uosLoongArch') {
          downloadUrl = this.downloadUrls.download_url_uosLoongArch;
        }
        // else { kirinArm kirinLoongArch uosArm uosLoongArch
        //   downloadUrl = this.downloadUrls.download_url_email;
        // }
      }
      return downloadUrl;
    }
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NfcG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nhso":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QdwX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-bg"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"container-sm"},[_c('div',{attrs:{"id":"synopsis"}},[_c('img',{staticClass:"w-100",attrs:{"src":"/static/navbar-0-01.png"}}),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"w-100",staticStyle:{"display":"block"},attrs:{"src":"/static/navbar-0-04.png"}}),_vm._v(" "),_c('P',{staticClass:"zpyq",staticStyle:{"top":"53%","left":"14%","margin-right":"10%"}},[_vm._v("　　以传承红色文化为主题展开3D模型设计，充分发挥自主想象力和创造力，体现红色精神和红色文化。"),_c('h',{staticStyle:{"color":"rgb(201,99,56)"}},[_vm._v("设计关键词：爱国、敬党、传承、创新、与时俱进。")])],1),_vm._v(" "),_c('p',{staticClass:"zpyq",staticStyle:{"top":"70%","left":"14%","margin-right":"10%"}},[_vm._v("　　以传承红色文化为背景，开展6期线上红色文化的3D模型课程。每期课程参赛者需线上签到打卡并根据每期的主题设计相应的3D模型。")]),_vm._v(" "),_c('p',{staticClass:"zpyq",staticStyle:{"top":"78%","left":"14%","margin-right":"10%"}},[_vm._v("----------------------------------------------")]),_vm._v(" "),_c('p',{staticClass:"zpyq",staticStyle:{"top":"81%","left":"14%","margin-right":"10%"}},[_vm._v("　　参赛的所有作品必须是原创，集体创作作品参赛需征得主创人员的同意。获奖作品将通过网络媒体公示\n。严禁抄袭、摹仿、拷贝他人的作品，一经查出，大赛组委会有权取消其参赛资格，若为获奖作品，则追回颁发奖励并进行公告。")])],1),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"w-100",staticStyle:{"display":"block"},attrs:{"src":"/static/navbar-0-02.png"}}),_vm._v(" "),_c('P',{staticClass:"jpjl",staticStyle:{"top":"59%","left":"21%","margin-right":"8%"}},[_c('h',{staticStyle:{"color":"rgb(111, 150, 222)"}},[_vm._v("创新决胜组(小学/中学组)、梦想进阶组")]),_c('br'),_vm._v(" "),_c('h',{staticStyle:{"color":"rgb(111, 150, 222)"}},[_vm._v("一等奖(1名)")]),_vm._v(" 奖学金人民币"),_c('h',{staticStyle:{"color":"rgb(207, 102, 57)"}},[_vm._v("2000")]),_vm._v("元及价值1000元奖品"),_c('br'),_vm._v(" "),_c('h',{staticStyle:{"color":"rgb(111, 150, 222)"}},[_vm._v("二等奖(3名)")]),_vm._v(" 奖学金人民币"),_c('h',{staticStyle:{"color":"rgb(207, 102, 57)"}},[_vm._v("800")]),_vm._v("元及价值1000元奖品"),_c('br'),_vm._v(" "),_c('h',{staticStyle:{"color":"rgb(111, 150, 222)"}},[_vm._v(" 三等奖(5名)")]),_vm._v(" 奖学金人民币"),_c('h',{staticStyle:{"color":"rgb(207, 102, 57)"}},[_vm._v("300")]),_vm._v("元及价值1000元奖品"),_c('br')],1),_vm._v(" "),_c('p',{staticClass:"jpjl",staticStyle:{"top":"85%","left":"21%","margin-right":"8%"}},[_vm._v(" 奖学金人民币"),_c('h',{staticStyle:{"color":"rgb(207, 102, 57)"}},[_vm._v("1000")]),_vm._v("元及价值1000元奖品")],1),_vm._v(" "),_c('p',{staticClass:"jpjl",staticStyle:{"top":"91%","left":"21%","margin-right":"8%"}},[_vm._v(" *以上凡是参赛选手、组织者均颁发奖状证书")])],1),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"w-100",staticStyle:{"display":"block"},attrs:{"src":"/static/navbar-0-03.png"}}),_vm._v(" "),_c('P',{staticClass:"zptj",staticStyle:{"top":"13%","left":"13%","margin-right":"9%"}},[_vm._v("　　比赛作品统一报送至大赛组委会邮箱："),_c('a',{staticStyle:{"color":"rgb(201,99,56)"},attrs:{"href":"mailto:cooperation@hesion3d.com"}},[_vm._v("cooperation@hesion3d.com")]),_vm._v("，作品由组委会工作人员统一审核筛选并上传至清软海芯科技的官网。")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',{staticClass:"zptj",staticStyle:{"top":"87%","left":"10%","margin-right":"8%"}},[_c('h',{staticStyle:{"color":"rgb(111, 150, 222)"}},[_vm._v("主办单位")]),_vm._v(" 　北京清软海芯科技有限公司 "),_c('br'),_vm._v(" "),_c('h',{staticStyle:{"color":"rgb(111, 150, 222)"}},[_vm._v("协办单位")]),_vm._v(" 　清华大学软件学院计算机辅助设计图形学与可视化研究所"),_c('br'),_vm._v(" "),_c('h',{staticStyle:{"color":"rgb(111, 150, 222)"}},[_vm._v("参赛平台")]),_vm._v(" 　LogoUp 3D官网、LogoUp 3D学习平台"),_c('br')],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"w-100",staticStyle:{"display":"block"},attrs:{"src":"/static/navbar-0-05.png"}}),_vm._v(" "),_c('P',{staticClass:"bqsm",staticStyle:{"top":"14%","left":"14%","margin-right":"8%"}},[_vm._v("\n            （一）每位报名者应是其参赛作品的作者或者合法的版权所有者。"),_c('br'),_vm._v("\n            （二）集体创作作品，报名者必须保证对作品有合法的版权，或以所有作者的名义参赛。"),_c('br'),_vm._v("\n            （三）作者拥有作品的全部版权，获奖作品由组委会联系相关机构进行产业转化，所得收益，另行签署协议。"),_c('br')]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)],1)]),_vm._v(" "),_c('div',{attrs:{"id":"detail"}},[_c('div',{staticClass:"w-100 bsxz",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"w-100",staticStyle:{"display":"block"},attrs:{"src":"/static/navbar-1-01.png"}}),_vm._v(" "),_c('P',{staticClass:"bsxz",staticStyle:{"top":"20%","left":"13%","margin-right":"9%"}},[_vm._v("　　即比赛时间4月6日起，举办方每隔14天会在官网发布比赛的项目主题，共计3个主题，参赛者即可根据主题进行模型设计。")]),_vm._v(" "),_c('p',{staticClass:"bsxz",staticStyle:{"top":"47%","left":"13%","margin-right":"9%"}},[_vm._v("　　即比赛时间4月9日起，举办方会每周在LogoUp3D学习平台上开展红色文化3D模型课程，参赛成员需准时打卡进班学习，并完成本节课布置的主题模型。")])],1),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticStyle:{"margin":"7.6%"}},[_c('div',{staticClass:"table-top"},[_vm._v("创新决胜组")]),_vm._v(" "),_c('table',{staticClass:"w-100",staticStyle:{"vertical-align":"middle","border":"3px solid rgb(87,120,187)","background":"rgb(10,29,78)"},attrs:{"border":"1px"}},[_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('tr',{staticClass:"table-td"},[_c('td',{staticClass:"table-td"},[_vm._v("4月6日-4月20日")]),_vm._v(" "),_c('td',{staticClass:"table-td"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/subject1?subject=1"}},[_vm._v("（第1轮）、红色记忆")])],1)]),_vm._v(" "),_c('tr',{staticClass:"table-td"},[_c('td',{staticClass:"table-td"},[_vm._v("4月21日-5月5日")]),_vm._v(" "),_c('td',{staticClass:"table-td"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/subject1?subject=2"}},[_vm._v("（第2轮）、党旗飘飘")])],1)]),_vm._v(" "),_c('tr',{staticClass:"table-td"},[_c('td',{staticClass:"table-td"},[_vm._v("5月6日-5月20日")]),_vm._v(" "),_c('td',{staticClass:"table-td"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/subject1?subject=3"}},[_vm._v("（第3轮）、红色烙印")])],1)]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"table-top"},[_vm._v("梦想进阶组")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)]),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"w-100",staticStyle:{"display":"block"},attrs:{"src":"/static/navbar-1-04.png"}}),_vm._v(" "),_c('P',{staticClass:"jfgz",staticStyle:{"top":"20%","left":"14%","margin-right":"9%"}},[_vm._v("　　总计三个作品，每个作品都会进行评审和打分，并计入总分。最终根据总分进行先后排名。")]),_vm._v(" "),_c('p',{staticClass:"jfgz",staticStyle:{"top":"45.5%","left":"19%","margin-right":"9%","color":"rgb(111, 150, 222)"}},[_vm._v(" 打卡签到")]),_vm._v(" "),_c('p',{staticClass:"jfgz",staticStyle:{"top":"49.5%","left":"19%","margin-right":"9%"}},[_vm._v(" 每次签到打卡计分5分，共六次总分30分，记录总分。")]),_vm._v(" "),_c('p',{staticClass:"jfgz",staticStyle:{"top":"56%","left":"19%","margin-right":"9%","color":"rgb(111, 150, 222)"}},[_vm._v(" 作品评审")]),_vm._v(" "),_c('p',{staticClass:"jfgz",staticStyle:{"top":"60%","left":"19%","margin-right":"9%"}},[_vm._v(" 作品依次进行评审打分，每个作品满分10分总共60分，6个作品分数进行累加，记录总分。")]),_vm._v(" "),_c('p',{staticClass:"jfgz",staticStyle:{"top":"72%","left":"19%","margin-right":"9%","color":"rgb(111, 150, 222)"}},[_vm._v(" 拉票环节计分")]),_vm._v(" "),_c('p',{staticClass:"jfgz",staticStyle:{"top":"76%","left":"19%","margin-right":"9%"}},[_vm._v(" 拉票环节为期7天，七天进行拉票点赞：")]),_vm._v(" "),_c('p',{staticClass:"jfgz",staticStyle:{"top":"82.9%","left":"19%","margin-right":"9%","color":"rgb(111, 150, 222)"}},[_vm._v(" 累计总成绩")])],1),_vm._v(" "),_c('img',{staticClass:"w-100",attrs:{"src":"/static/navbar-1-05.png"}})]),_vm._v(" "),_c('div',{attrs:{"id":"signup"}},[_c('img',{staticClass:"w-100",attrs:{"src":"/static/navbar-2-01.png"}}),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('div',{staticClass:"w-100 ",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"w-100",staticStyle:{"display":"block"},attrs:{"src":"/static/navbar-2-04.png"}}),_vm._v(" "),_c('P',{staticClass:"sysm",staticStyle:{"top":"8%","left":"31%","margin-right":"9%","color":"rgb(111, 150, 222)"}},[_vm._v("比赛期间LogoUp软件使用说明")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('p',{staticClass:"sysm",staticStyle:{"top":"34.2%","left":"17%","margin-right":"9%"}},[_vm._v(" 已经下载使用过教育体验版的学生，建议购买价格200元的LogoUp软件比赛套餐（无权限限制+7节免费在线课程），有效期3个月。")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel splash",attrs:{"id":"carouselExampleIndicators","data-ride":"carousel"}},[_c('ol',{staticClass:"carousel-indicators"},[_c('li',{staticClass:"active",attrs:{"data-target":"#carouselExampleIndicators","data-slide-to":"0"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#carouselExampleIndicators","data-slide-to":"1"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#carouselExampleIndicators","data-slide-to":"2"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"carousel-item splash active"},[_c('img',{staticClass:"d-block w-100",attrs:{"src":"/static/banner-competition.jpg","alt":"..."}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item splash"},[_c('img',{staticClass:"d-block w-100",attrs:{"src":"/static/banner-competition.jpg","alt":"..."}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item splash"},[_c('img',{staticClass:"d-block w-100",attrs:{"src":"/static/banner-competition.jpg","alt":"..."}})])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-prev",attrs:{"href":"#carouselExampleIndicators","role":"button","data-slide":"prev"}},[_c('span',{staticClass:"carousel-control-prev-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-next",attrs:{"href":"#carouselExampleIndicators","role":"button","data-slide":"next"}},[_c('span',{staticClass:"carousel-control-next-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-1 container-fluid",attrs:{"id":"nav-1"}},[_c('nav',{staticClass:"navbar navbar-light justify-content-center"},[_c('ul',{staticClass:"nav row justify-content-center"},[_c('li',{staticClass:"nav-item col-5 col-sm-3"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#synopsis"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/navbar-0.png"}})])]),_vm._v(" "),_c('li',{staticClass:"nav-item col-5 col-sm-3"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#detail"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/navbar-1.png"}})])]),_vm._v(" "),_c('li',{staticClass:"nav-item col-5 col-sm-3"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#signup"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/navbar-2.png"}})])]),_vm._v(" "),_c('li',{staticClass:"nav-item col-5 col-sm-3"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#share"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/navbar-3.png"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"zptj",staticStyle:{"top":"34%","left":"13%","margin-right":"9%"}},[_vm._v(" \n　　1、递交文件命名格式：组别+所在市+学校名+参赛学生（例：创新决胜组(小学/中学组)+云浮市+郁南实验中学+王小明）；"),_c('br'),_vm._v("\n　　2、提交文件内容：作品说明文档(参考附件一)+作品源文件（文件格式为logoup或stl等）；"),_c('br'),_vm._v("\n　　3、（可选）设计参赛模型亦可进行实体搭建和零件装配，并制作相关功能演示动画或视频。如进行实体搭建后，提交作品内容如下："),_c('br'),_vm._v("\n　　①、提交文件包括：设计说明文档（WORD 文档），源文件，演示动画（建议格式为：MP4）和作品缩略图。"),_c('br'),_vm._v("\n　　②、作品（含设计说明文档、源文件、演示动画、作品缩略图）大小建议不超过 100MB。\n")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"bqsm",staticStyle:{"top":"50%","left":"14%","margin-right":"8%"}},[_vm._v("  \n             \n          　　*本届大赛各项活动的最终解释权归大赛举办方北京清软海芯科技有限公司所有"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"bqsm",staticStyle:{"top":"68%","left":"14%","margin-right":"8%"}},[_vm._v(" \n           大赛组委会秘书处"),_c('br'),_vm._v("\n          地址：北京市海淀区上地信息路11号彩虹大厦北楼西401"),_c('br'),_vm._v("\n         电话："),_c('a',{staticStyle:{"color":"rgb(201,99,56)"},attrs:{"href":"tel:010-62966651"}},[_vm._v("010-62966651")]),_c('br'),_vm._v("\n        邮箱："),_c('a',{staticStyle:{"color":"rgb(201,99,56)"},attrs:{"href":"mailto:cooperation@hesion3d.com"}},[_vm._v("cooperation@hesion3d.com")]),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://appxd0aquww5168.h5.xiaoeknow.com","target":"_Blank"}},[_c('img',{staticClass:"w-100",attrs:{"src":"/static/navbar-1-02.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"table-header",staticStyle:{"width":"33%"}},[_vm._v("日期")]),_vm._v(" "),_c('td',{staticClass:"table-header"},[_vm._v("日程内容")]),_vm._v(" "),_c('td',{staticClass:"table-header"},[_vm._v("地点")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"table-td"},[_vm._v("4月9日")]),_vm._v(" "),_c('td',{staticClass:"table-td"},[_vm._v("软件介绍及赛事答疑")]),_vm._v(" "),_c('td',{staticClass:"table-td",staticStyle:{"font-size":"1vm","text-align":"center"},attrs:{"rowspan":"5"}},[_vm._v("\n                 线上LogoUp3D官网\n                "),_c('br'),_vm._v("http://logoup3d.com/\n                \n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-td"},[_c('td',{staticClass:"table-td"},[_vm._v("6月25日")]),_vm._v(" "),_c('td',{staticClass:"table-td"},[_vm._v("赛事总结及公布比赛成绩")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"table-detail"},[_vm._v("注：作品提交的截止日期均为每轮比赛的截止日期，例如：第一轮比赛作品提交的截止日期为4月20日下午六点前，以此类推。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"w-100",staticStyle:{"border":"3px solid rgb(87,120,187)","background":"rgb(10,29,78)"},attrs:{"border":"1px"}},[_c('tr',[_c('td',{staticClass:"table-header",staticStyle:{"width":"33%"}},[_vm._v("日期")]),_vm._v(" "),_c('td',{staticClass:"table-header"},[_vm._v("日程内容")]),_vm._v(" "),_c('td',{staticClass:"table-header"},[_vm._v("地点")])]),_vm._v(" "),_c('tr',{staticStyle:{"color":"white"}},[_c('td',{staticClass:"table-td"},[_vm._v("4月9日")]),_vm._v(" "),_c('td',{staticClass:"table-td"},[_vm._v("软件介绍及赛事答疑")]),_vm._v(" "),_c('td',{staticClass:"table-td",staticStyle:{"text-align":"center"},attrs:{"rowspan":"9"}},[_c('a',{staticStyle:{"color":"rgb(111, 150, 222)","text-decoration":"underline"},attrs:{"href":"https://appxd0aquww5168.h5.xiaoeknow.com"}},[_vm._v("LogoUp 3D学习平台")])])]),_vm._v(" "),_c('tr',{staticStyle:{"color":"white","font-size":"1vm"}},[_c('td',{staticClass:"table-td"},[_vm._v("4月17日-4月23日")]),_vm._v(" "),_c('td',{staticClass:"table-td",staticStyle:{"text-align":"left"}},[_vm._v("1、中国共产党的成立")])]),_vm._v(" "),_c('tr',{staticStyle:{"color":"white","font-size":"1vm"}},[_c('td',{staticClass:"table-td"},[_vm._v("4月24日-4月30日")]),_vm._v(" "),_c('td',{staticClass:"table-td",staticStyle:{"text-align":"left"}},[_vm._v("2、清华大学的历史故事")])]),_vm._v(" "),_c('tr',{staticStyle:{"color":"white","font-size":"1vm"}},[_c('td',{staticClass:"table-td"},[_vm._v("5月8日-5月14日")]),_vm._v(" "),_c('td',{staticClass:"table-td",staticStyle:{"text-align":"left"}},[_vm._v("3、新中国的成立")])]),_vm._v(" "),_c('tr',{staticStyle:{"color":"white","font-size":"1vm"}},[_c('td',{staticClass:"table-td"},[_vm._v("5月15日-5月21日")]),_vm._v(" "),_c('td',{staticClass:"table-td",staticStyle:{"text-align":"left"}},[_vm._v("4、改革开放")])]),_vm._v(" "),_c('tr',{staticStyle:{"color":"white","font-size":"1vm"}},[_c('td',{staticClass:"table-td"},[_vm._v("5月22日-5月28日")]),_vm._v(" "),_c('td',{staticClass:"table-td",staticStyle:{"text-align":"left"}},[_vm._v("5、科技强国")])]),_vm._v(" "),_c('tr',{staticStyle:{"color":"white","font-size":"1vm"}},[_c('td',{staticClass:"table-td"},[_vm._v("5月29日-6月6日")]),_vm._v(" "),_c('td',{staticClass:"table-td",staticStyle:{"text-align":"left"}},[_vm._v("6、教育先锋")])]),_vm._v(" "),_c('tr',{staticStyle:{"color":"white","font-size":"1vm"}},[_c('td',{staticClass:"table-td"},[_vm._v("6月7日-6月14日")]),_vm._v(" "),_c('td',{staticClass:"table-td",staticStyle:{"text-align":"left"}},[_vm._v("7、拉票环节")])]),_vm._v(" "),_c('tr',{staticStyle:{"color":"white","font-size":"1vm"}},[_c('td',{staticClass:"table-td"},[_vm._v("6月25日")]),_vm._v(" "),_c('td',{staticClass:"table-td",staticStyle:{"text-align":"left"}},[_vm._v("赛事总结及公布比赛成绩")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('p',{staticClass:"table-detail"},[_vm._v("注：作品提交的截止日期均为每轮比赛的截止日期，例如：第一轮比赛作品提交的截止日期为4月23日下午六点前，以此类推。")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/static/competition.zip","target":"_blank"}},[_c('img',{staticClass:"w-100",attrs:{"src":"/static/navbar-2-02.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://wj.qq.com/s2/8180302/bcc0","target":"_Blank"}},[_c('img',{staticClass:"w-100",attrs:{"src":"/static/navbar-2-03.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"sysm",staticStyle:{"top":"18.5%","left":"17%","margin-right":"9%"}},[_vm._v(" 未使用过LogoUp软件的学生可以在清软海芯官网上下载"),_c('br'),_vm._v("LogoUp 3D免费试用版本（150行代码，试用期3个月）。")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SDEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path !== '/message')?_c('div',{staticClass:"container title-bar"},[_c('nav',{staticClass:"navbar navbar-expand-xl logoup-navbar"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarNav","aria-controls":"navbarNav","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30","width":"30","height":"30","focusable":"false"}},[_c('title',[_vm._v("Menu")]),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-miterlimit":"10","d":"M4 7h22M4 15h22M4 23h22"}})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarNav"}},[_c('ul',{staticClass:"navbar-nav"},[_c('li',{staticClass:"nav-item active"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/home"}},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("LogoUp 3D")]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("三维创新设计平台")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/competition"}},[_vm._v("青少年创意设计大赛")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/course"}},[_vm._v("课程资源")])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/about"}},[_vm._v("关于我们")])],1)])])])]):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.$route.path !== '/message')?_c('div',{staticClass:"foot-bar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"foot-section col-lg-2 col-sm-4 col-6"},[_c('h3',[_vm._v("关于公司")]),_vm._v(" "),_c('router-link',{staticClass:"foot-link",attrs:{"to":"/about"}},[_vm._v("公司简介")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://hesion3d.com/#/team"}},[_vm._v("合伙人与团队")]),_vm._v(" "),_c('router-link',{staticClass:"foot-link",attrs:{"to":"/gymnasium"}},[_vm._v("3D技术科普体验馆")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://hesion3d.com/#/job"}},[_vm._v("加入我们")])],1),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_vm._m(6)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_c('img',{staticStyle:{"width":"3.2rem"},attrs:{"src":"/static/logoup-512.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"https://hesion3d.com/#/"}},[_vm._v("3D打印机")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot-section col-lg-2 col-sm-4 col-6"},[_c('h3',[_vm._v("客户服务")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://hesion3d.com/#/buy"}},[_vm._v("购买指南")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://hesion3d.com/#/retailer"}},[_vm._v("渠道与大客户服务")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://m.kuaidi100.com","target":"_blank"}},[_vm._v("快递查询")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot-section col-lg-2 col-sm-4 col-6"},[_c('h3',[_vm._v("法律说明")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://hesion3d.com/#/policy"}},[_vm._v("法律声明")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://hesion3d.com/#/privacy"}},[_vm._v("隐私条款")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://hesion3d.com/#/property"}},[_vm._v("知识产权声明")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot-section col-lg-2 col-sm-4 col-6"},[_c('h3',[_vm._v("媒体中心")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://hesion3d.com/#/works"}},[_vm._v("作品展示")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://hesion3d.com/#/media"}},[_vm._v("媒体资源")]),_vm._v(" "),_c('a',{staticClass:"foot-link",attrs:{"href":"http://hesion3d.com/#/investment"}},[_vm._v("投资人关系")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot-section ml-lg-auto col-lg-3  col-md-5 col-sm-6 col-12"},[_c('a',{attrs:{"href":"#/contact"}},[_c('h3',[_vm._v("联系我们")])]),_vm._v(" "),_c('div',{staticClass:"phone"},[_vm._v("010-6296-6651")]),_vm._v(" "),_c('div',{staticClass:"exp"},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("周一至周五 9:00-18:00")]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("（仅收普通话费）")])]),_vm._v(" "),_c('div',{staticClass:"email"},[_c('a',{attrs:{"href":"mailto:service@hesion3d.com"}},[_vm._v("service@hesion3d.com")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright-bar"},[_c('div',[_vm._v("版权所有 © 2014-2021, 北京清软海芯科技有限公司。所有权利保留。")]),_vm._v(" "),_c('div',{staticClass:"miibeian"},[_c('a',{staticStyle:{"margin-right":"1em","white-space":"nowrap"},attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("京ICP备14057314号")]),_vm._v(" "),_c('a',{staticStyle:{"white-space":"nowrap"},attrs:{"href":"http://www.miibeian.gov.cn/","target":"_blank"}},[_vm._v("京公安网备 11010802017110 号")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"#dedede","height":"2px","overflow":"hidden"}},[_vm._v("\n          海芯, 清软, 优琢, 3D, 打印, 打印机, 增材制造, 熔融沉积, 海芯科技, Neobox, 打印工场, mall3d, printing, hesion, fdm, 小飞侠, pancake, 三弟画饼。\n          海芯科技是一家 3D 打印机制造商和 3D 打印服务提供商，致力于让所有公众享受到 3D 打印技术变革带来的方便和欣喜，推动 3D 打印技术和娱乐的全面对接。\n          海芯科技 - 智慧商用 3D 打印技术引领者\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UJfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "Y/FV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-page"},[_c('div',{staticClass:"container msg-body"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',{staticClass:"msg-actions"},[_vm._l((_vm.actionLinks),function(item,index){return _c('div',{key:item.url,staticClass:"msg-action-row"},[_c('a',{staticClass:"msg-btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openExternal(item.url)}}},[_vm._v(_vm._s(item.label))])])}),_vm._v(" "),_c('div',{staticClass:"msg-action-row"},[_c('a',{staticClass:"msg-btn msg-btn-activate",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.activateCompetition($event)}}},[_vm._v("3D大赛专属激活")])])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"msg-section"},[_c('div',{staticClass:"msg-section-content"},[_c('h2',{staticClass:"msg-section-title"},[_vm._v("2026年3D大赛等你来！")]),_vm._v(" "),_c('p',{staticClass:"msg-section-subtitle"},[_vm._v("第19届全国3D大赛 · 数字化设计与制造大赛")]),_vm._v(" "),_c('p',{staticClass:"msg-desc"},[_vm._v("\n          全国三维数字化创新设计大赛（简称\"3D大赛\"）历经十八载耕耘，已成为\n          "),_c('strong',[_vm._v("全国规模最大的三维设计赛事")]),_vm._v("，每年吸引\n          "),_c('strong',[_vm._v("100+ 万名选手")]),_vm._v("同台竞技。\n        ")]),_vm._v(" "),_c('p',{staticClass:"msg-desc"},[_vm._v("\n          今年，\"数字化设计与制造大赛\"全面升级，以\n          "),_c('strong',[_vm._v("「设计创意 · 数智制造」")]),_vm._v("为主题，聚焦\n          AI + 数字化设计、数字化检测、数字化制造 / 3D 打印等硬核技术，\n          立足专业课程升级新要求，带你从创意构思到打印实物，完整体验工业级全流程创新闭环。\n        ")]),_vm._v(" "),_c('p',{staticClass:"msg-desc"},[_vm._v("\n          大赛设"),_c('strong',[_vm._v("高职高专组、研究生 / 本科生组")]),_vm._v("及"),_c('strong',[_vm._v("青少年组")]),_vm._v("。\n          只要作品能体现\"程序之美\"与\"设计之美\"的融合，这里就是你的主场！\n        ")]),_vm._v(" "),_c('p',{staticClass:"msg-desc msg-sponsor"},[_vm._v("\n          北京清软海芯科技有限公司为大赛技术支持单位，参赛选手可使用\n          "),_c('strong',[_vm._v("LogoUp 3D")]),_vm._v(" 软件设计作品参赛。\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"msg-section"},[_c('div',{staticClass:"msg-section-content"},[_c('h2',{staticClass:"msg-section-title"},[_vm._v("大赛安排")]),_vm._v(" "),_c('table',{staticClass:"msg-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("赛程阶段")]),_vm._v(" "),_c('th',[_vm._v("时间")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("比赛报名 / 项目作品提交")]),_vm._v(" "),_c('td',{staticClass:"msg-time"},[_vm._v("6月5日 — 8月31日")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("初赛 / 校赛选拔")]),_vm._v(" "),_c('td',{staticClass:"msg-time"},[_vm._v("6月 — 8月")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("省 / 区域赛选拔")]),_vm._v(" "),_c('td',{staticClass:"msg-time"},[_vm._v("9月 — 10月")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("国赛 / 总决赛")]),_vm._v(" "),_c('td',{staticClass:"msg-time"},[_vm._v("11月")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__("wUZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_competition__ = __webpack_require__("I+Sz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_course__ = __webpack_require__("61ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_about__ = __webpack_require__("zRCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_download__ = __webpack_require__("DmJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_subject1__ = __webpack_require__("J1ck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_gymnasium__ = __webpack_require__("gohQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_gymnasiumDetail__ = __webpack_require__("8aqV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_message__ = __webpack_require__("AVWw");
/*
 * @Author: ycm-windows hesion3d@hesion3d.com
 * @Date: 2021-04-15 18:24:37
 * @LastEditors: ycm-windows hesion3d@hesion3d.com
 * @LastEditTime: 2022-10-27 17:25:17
 * @FilePath: \logoup_portal\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */











// import EntryForm from '@/components/entryForm';
// import QueryForm from '@/components/queryForm';
// import EntryFormFinal from '@/components/entryFormFinal';
// import QueryFormFinal from '@/components/queryFormFinal';
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home__["a" /* default */]
  }, {
    path: '/competition',
    name: 'competition',
    component: __WEBPACK_IMPORTED_MODULE_3__components_competition__["a" /* default */]
  }, {
    path: '/subject1',
    name: 'subject1',
    component: __WEBPACK_IMPORTED_MODULE_7__components_subject1__["a" /* default */]
  }, {
    path: '/course',
    name: 'course',
    component: __WEBPACK_IMPORTED_MODULE_4__components_course__["a" /* default */]
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_5__components_about__["a" /* default */]
  }, {
    path: '/gymnasium',
    name: 'gymnasium',
    component: __WEBPACK_IMPORTED_MODULE_8__components_gymnasium__["a" /* default */]
  }, {
    path: '/gymnasiumDetail',
    name: 'gymnasiumDetail',
    component: __WEBPACK_IMPORTED_MODULE_9__components_gymnasiumDetail__["a" /* default */]
  }, {
    path: '/message',
    name: 'message',
    component: __WEBPACK_IMPORTED_MODULE_10__components_message__["a" /* default */]
  },
  // {
  //   path: '/entryForm',
  //   name: 'entryForm',
  //   component: EntryForm,
  // },
  // {
  //   path: '/queryForm',
  //   name: 'queryForm',
  //   component: QueryForm,
  // },
  // {
  //   path: '/entryFormFinal',
  //   name: 'entryFormFinal',
  //   component: EntryFormFinal,
  // },
  // {
  //   path: '/queryFormFinal',
  //   name: 'queryFormFinal',
  //   component: QueryFormFinal,
  // },
  {
    path: '/download',
    name: 'download',
    component: __WEBPACK_IMPORTED_MODULE_6__components_download__["a" /* default */]
  }, {
    path: '/download/:source',
    name: 'h',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home__["a" /* default */]
  }]
}));

/***/ }),

/***/ "aJe3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c7O/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"synopsis"}},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.imgUrl}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "enFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"jumbotron jumbotron-fluid splash"},[_c('div',[_c('div',{staticClass:"title"},[_c('div',{staticClass:"title-line-1"},[_vm._v("LogoUp 3D 为 STEAM 教育而生")]),_vm._v(" "),_c('div',{staticClass:"title-line-2",staticStyle:{"font-weight":"400","margin-top":"0.3em"}},[_vm._v("配套面向不同层次的教程体系")]),_vm._v(" "),_c('div',{staticClass:"title-line-1",staticStyle:{"font-weight":"400"}},[_vm._v("快速入门 >> 进阶拓展 >> 高级开发")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3em","margin-bottom":"0.8em","text-align":"right","text-shadow":"none"}},[_vm._v("\n          单击下方观看面向教师和工程师的视频教程"),_c('br'),_vm._v(" "),_vm._v("\n           《LogoUp 程序式三维建模软件 从入门到精通》教程\n        ")]),_vm._v(" "),_c('div',[_c('a',{staticClass:"download",attrs:{"href":"https://wx84eef5a05cc1729b.h5.xiaoe-tech.com","target":"_blank"}},[_c('img',{attrs:{"src":"/static/studycenter.png"}}),_vm._v("\n            学习中心\n          ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-shadow":"none","margin-top":"1em"}},[_vm._v("更多付费教程请微信登陆⌊学习中心⌉")])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"content-section"},[_c('h3',[_vm._v("\n        从入门到精通\n        "),_vm._v(" "),_c('div',[_vm._v("面向教师、工程师和设计师的 8 课时视频实操教程")])]),_vm._v(" "),_c('div',{staticClass:"row align-items-center justify-content-center"},[_c('div',{staticClass:"col-6 col-sm-4 col-md-3 col-lg-2 ml-auto mr-auto",staticStyle:{"text-align":"center","margin-top":"1em"}},[_c('img',{attrs:{"src":"/static/bookshelf.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-8 col-md-9 col-lg-4 ml-auto mr-auto intro",staticStyle:{"margin-top":"1em"}},[_c('h4',[_vm._v("视频使用教程")]),_vm._v(" "),_c('div',[_vm._v("\n            8 课时（每课 45 分钟）视频使用教程"),_c('br'),_vm._v(" "),_vm._v("\n             LogoUp 配套教程\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-4 col-md-3 col-lg-2 ml-auto mr-auto",staticStyle:{"text-align":"center","margin-top":"1em"}},[_c('img',{attrs:{"src":"/static/female.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-8 col-md-9 col-lg-4 ml-auto mr-auto intro",staticStyle:{"margin-top":"1em"}},[_c('h4',[_vm._v("面向教师、工程师和设计师")]),_vm._v(" "),_c('div',[_vm._v("\n            边看视频边实操，学习使用 LogoUp 语言"),_c('br'),_vm._v("\n            零基础快速上手，深入学习编程和造型理念\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('h4',{staticStyle:{"margin-top":"2em"}},[_vm._v("课程内容和安排")]),_vm._v(" "),_c('table',{staticStyle:{"margin-top":"2em","width":"100%"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tr',[_c('th',{staticStyle:{"width":"3em"}}),_vm._v(" "),_c('th',{staticStyle:{"width":"6em"}},[_vm._v("课程名称")]),_vm._v(" "),_c('th',{staticStyle:{"width":"7em"}},[_vm._v("理论知识")]),_vm._v(" "),_c('th',[_vm._v("LogoUp 语法")]),_vm._v(" "),_c('th',[_vm._v("软件操作")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("第一课")]),_vm._v(" "),_c('td',[_vm._v("快速入门")]),_vm._v(" "),_c('td',[_vm._v("平面游标移动")]),_vm._v(" "),_c('td',[_vm._v("DRAW / GO / TURN / DONE")]),_vm._v(" "),_c('td',[_vm._v("新建、保存、打开、积木基本操作、鼠标视图操作")])]),_vm._v(" "),_c('tr',{staticStyle:{"background":"#f4f4f4"}},[_c('th',[_vm._v("第二课")]),_vm._v(" "),_c('td',[_vm._v("进阶二维绘图")]),_vm._v(" "),_c('td',[_vm._v("内环和外环")]),_vm._v(" "),_c('td',[_vm._v("HOME / CLEAR / WIDTH / FILL")]),_vm._v(" "),_c('td',[_vm._v("绘制复杂的形状、草图视图")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("第三课")]),_vm._v(" "),_c('td',[_vm._v("三维绘图")]),_vm._v(" "),_c('td',[_vm._v("空间姿态")]),_vm._v(" "),_c('td',[_vm._v("YAW / PITCH / ROLL / BODY / UP")]),_vm._v(" "),_c('td',[_vm._v("标准视图操作、隐藏显示视图元素")])]),_vm._v(" "),_c('tr',{staticStyle:{"background":"#f4f4f4"}},[_c('th',[_vm._v("第四课")]),_vm._v(" "),_c('td',[_vm._v("进阶三维设计")]),_vm._v(" "),_c('td',[_vm._v("回转面")]),_vm._v(" "),_c('td',[_vm._v("SCALE / JUMP / LINK / RESET / COLOR")]),_vm._v(" "),_c('td',[_vm._v("回转面生成")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("第五课")]),_vm._v(" "),_c('td',[_vm._v("重复结构绘制")]),_vm._v(" "),_c('td',[_vm._v("循环和重复")]),_vm._v(" "),_c('td',[_vm._v("REPEAT / VAR")]),_vm._v(" "),_c('td',[_vm._v("重复结构积木设计、循环嵌套、缩进")])]),_vm._v(" "),_c('tr',{staticStyle:{"background":"#f4f4f4"}},[_c('th',[_vm._v("第六课")]),_vm._v(" "),_c('td',[_vm._v("过程与函数")]),_vm._v(" "),_c('td',[_vm._v("过程与函数、标准库")]),_vm._v(" "),_c('td',[_vm._v("FUNC / REPEAT UNTIL / WHEN")]),_vm._v(" "),_c('td',[_vm._v("自动排版、命名规则")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("第七课")]),_vm._v(" "),_c('td',[_vm._v("绝对坐标绘图")]),_vm._v(" "),_c('td',[_vm._v("三维坐标系")]),_vm._v(" "),_c('td',[_vm._v("GOTO / TURNTO / YAWTO / PITCHTO / ROLLTO")]),_vm._v(" "),_c('td',[_vm._v("角度编辑框、吸附操作、注释、三角函数")])]),_vm._v(" "),_c('tr',{staticStyle:{"background":"#f4f4f4"}},[_c('th',[_vm._v("第八课")]),_vm._v(" "),_c('td',[_vm._v("形体的组合")]),_vm._v(" "),_c('td',[_vm._v("布尔运算")]),_vm._v(" "),_c('td',[_vm._v("ERASE / SUBTRACT")]),_vm._v(" "),_c('td',[_vm._v("3D 打印、输出、打印设置、模型统计")])])])])]),_vm._v(" "),_c('div',{staticClass:"content-section",staticStyle:{"margin-top":"2em"}},[_c('h3',[_vm._v("\n        尼奥博士的实验室\n        "),_c('div',[_vm._v("面向青少年的商业 STEAM 课程培训体系")])]),_vm._v(" "),_c('img',{staticStyle:{"float":"right","border-radius":"16px","margin-right":"2em"},attrs:{"src":"/static/course-book.jpg","width":"93%"}}),_vm._v(" "),_c('div',{staticClass:"slide",staticStyle:{"margin-left":"20%","margin-top":"4em","color":"#59a3a6","font-weight":"bold"}},[_vm._v("\n         "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"24px"}},[_vm._v("哥哥，你怎么又把实验室炸了？")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v("让我们来一起重建实验室吧！")])]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n        《尼奥博士的实验室》讲述的是八岁女孩儿莉莉和他的科学家哥哥尼奥博士在家中发生的各种趣事。\n        课程体系分为 12 个课时，以莉莉和尼奥博士之间发生的有趣事件贯穿始终，\n        将课程任务和故事融合在一起，通过课程任务，讲授基于 LogoUp 语言的三维设计、程序设计和 3D 打印制作的知识和技能，\n        培养学生的"),_c('b',[_vm._v("独立思考能力")]),_vm._v("、"),_c('b',[_vm._v("创新创造兴趣")]),_vm._v("、"),_c('b',[_vm._v("项目管理能力")]),_vm._v("和"),_c('b',[_vm._v("合作交流能力")]),_vm._v("。\n      ")]),_vm._v(" "),_c('div',{staticClass:"row align-items-center justify-content-md-center"},[_c('div',{staticClass:"col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2",staticStyle:{"text-align":"center","margin-top":"1em"}},[_c('img',{attrs:{"src":"/static/bookshelf.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-9 col-md-9 col-lg-4 intro"},[_c('h4',[_vm._v("适合于课堂的教学体系")]),_vm._v(" "),_c('div',[_vm._v("\n            12 课时，每节课 40 分钟"),_c('br'),_vm._v("\n            面向青少年编程、三维和创造性学习"),_c('br'),_vm._v("\n            零基础冷启动，10 岁以上即可\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2",staticStyle:{"text-align":"center","margin-top":"1em"}},[_c('img',{attrs:{"src":"/static/vessel.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-9 col-md-9 col-lg-4 intro"},[_c('h4',[_vm._v("目标驱动的 STEAM 教育理念")]),_vm._v(" "),_c('div',[_vm._v("\n            每节课以故事引入给出目标"),_c('br'),_vm._v("\n            以目标驱动实践技能和理论知识学习"),_c('br'),_vm._v("\n            巩固传统课程、突出实战能力\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2",staticStyle:{"text-align":"center","margin-top":"1em"}},[_c('img',{attrs:{"src":"/static/check.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-9 col-md-9 col-lg-4 intro"},[_c('h4',[_vm._v("培养多方面能力素质")]),_vm._v(" "),_c('div',[_vm._v("\n            独立思考解决问题的能力"),_c('br'),_vm._v("\n            不断学习新技能创新创造的能力"),_c('br'),_vm._v("\n            管理项目进展与朋友合作的能力\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2",staticStyle:{"text-align":"center","margin-top":"1em"}},[_c('img',{attrs:{"src":"/static/programming.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-9 col-md-9 col-lg-4 intro"},[_c('h4',[_vm._v("紧扣设计、3D 打印和编程")]),_vm._v(" "),_c('div',[_vm._v("\n            学习基本的程序设计能力"),_c('br'),_vm._v("\n            掌握三维设计技能，可以设计出有用作品"),_c('br'),_vm._v("\n            能够通过 3D 打印制造出交付物\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"content-section",staticStyle:{"margin-top":"8em"}},[_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gohQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gymnasium_vue__ = __webpack_require__("pJxn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9108bec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gymnasium_vue__ = __webpack_require__("LI+b");
function injectStyle (ssrContext) {
  __webpack_require__("3bwd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9108bec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gymnasium_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9108bec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gymnasium_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lXEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content-section"},[_c('h3',[_vm._v("\n        新余3D技术科普体验馆\n        ")]),_vm._v(" "),_c('div',{staticClass:"slide",domProps:{"innerHTML":_vm._s(_vm.gymnasiumDetail[_vm.view].detail)}}),_vm._v(" "),_c('div',[_c('img',{staticStyle:{"border-radius":"16px","width":"100%","heigth":"300px"},attrs:{"src":_vm.gymnasiumDetail[_vm.view].imageUrl}})])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section",staticStyle:{"margin-top":"2"}},[_vm._v("\n       "),_c('br'),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nbJS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "competition",
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    var navDiv = document.getElementById("nav-1");
    var mt = navDiv.offsetTop;
    // console.log(mt)
    window.onscroll = function () {
      var t = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(t)
      if (t > mt) {
        navDiv.style.position = "fixed";
        navDiv.style.top = "0";
      } else {
        navDiv.style.position = "relative";
      }
    };
  }
});

/***/ }),

/***/ "ngeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'message',
  data: function data() {
    return {
      copiedIndex: -1,
      actionLinks: [{
        label: '全国3D大赛数字化设计与制造大赛官网',
        url: 'https://3dshow.3ddl.net/i/DM'
      }, {
        label: '全国3D大赛数字化设计与制造大赛参赛通知',
        url: 'https://3ddl-oss.oss-cn-beijing.aliyuncs.com/2026/3dds/202619swszhcxtz.pdf'
      }]
    };
  },

  methods: {
    activateCompetition: function activateCompetition() {
      var payload = { action: 'competitionActivate' };
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(payload, '*');
      }
    },
    openExternal: function openExternal(url) {
      var payload = { action: 'openExternal', url: url };
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(payload, '*');
      }
    },
    copyUrl: function copyUrl(url, index) {
      var _this = this;

      var done = function done() {
        _this.copiedIndex = index;
        if (_this.copyTimer) clearTimeout(_this.copyTimer);
        _this.copyTimer = setTimeout(function () {
          _this.copiedIndex = -1;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {
          _this.fallbackCopy(url, done);
        });
        return;
      }
      this.fallbackCopy(url, done);
    },
    fallbackCopy: function fallbackCopy(text, done) {
      var input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e) {
        // ignore
      }
      document.body.removeChild(input);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.copyTimer) clearTimeout(this.copyTimer);
  }
});

/***/ }),

/***/ "pJxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about',
  data: function data() {
    return {
      subject: [{ title: "新余3D科普体验馆", centent: "\u8363\u83B7\u201C\u6C5F\u897F\u7701\u79D1\u666E\u6559\u80B2\u57FA\u5730\u201D\u3001\u201C\u65B0\u4F59\u5E02\u79D1\u666E\u6559\u80B2\u57FA\u5730\u201D\u3001\u201C\u65B0\u4F59\u5E02\u4E2D\u5C0F\u5B66\u7814\u5B66\u65C5\u884C(\u6821\u5916\u5B9E\u8DF5)\u57FA\u5730\u201D\u3001\u201C\u9752\u5C11\u5E74\u79D1\u666E\u77E5\u8BC6\u6559\u80B2\u57FA\u5730\u201D" }, { title: "荆州3D科普体验馆", centent: "\u8363\u83B7\u201C\u6E56\u5317\u7701\u53CC\u521B\u4E0E\u5148\u8FDB\u5236\u9020\u6559\u80B2\u793A\u8303\u57FA\u5730\u201D\u3001\u201C\u6E56\u5317\u7701\u79D1\u666E\u6559\u80B2\u57FA\u5730\u201D\u3001\u201C\u53CC\u521B\u4E0E\u5148\u8FDB\u5236\u9020\u6559\u80B2\u793A\u8303\u57FA\u5730\u201D" }, { title: "云浮3D科普体验馆", centent: "\u8363\u83B7\u201C\u5E7F\u4E1C\u7701\u9752\u5C11\u5E74\u79D1\u6280\u6559\u80B2\u57FA\u5730\u201D\u3001\u201C\u5E7F\u4E1C\u7701\u79D1\u666E\u6559\u80B2\u57FA\u5730\u201D\u3001\u201C\u5E7F\u4E1C\u7701\u5341\u4F73\u79D1\u666E\u6559\u80B2\u57FA\u5730\u201D\u79F0\u53F7" }]

    };
  }
});

/***/ }),

/***/ "pm3Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uZ9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"jumbotron jumbotron-fluid splash"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-xl-5 title"},[_c('div',{staticClass:"splash-subtitle"},[_vm._v("源自清华的 STEAM 教育力作")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"splash-subtitle",staticStyle:{"font-weight":"400"}},[_vm._v("积木式自由三维设计开放平台")]),_vm._v(" "),_c('div',{staticClass:"splash-hint"},[_vm._v("点击下面按钮下载最新版本")]),_vm._v(" "),_c('div',{staticClass:"container download-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('a',{staticClass:"download",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.download(_vm.$route.params.source == 'email' ? 'email' : 'windows')}}},[_c('img',{attrs:{"src":"/static/windows.png"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.version))]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("Windows 7/8/10")])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('a',{staticClass:"download",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.download('linux')}}},[_c('img',{attrs:{"src":"/static/ubuntu.png"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.version))]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("Ubuntu 12.04+")])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('a',{staticClass:"download",attrs:{"target":"_blank","data-target":"#kirinOptionsModal","data-toggle":"modal"}},[_c('img',{attrs:{"src":"/static/kirin.png"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.version))]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("国产系统+")])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"kirinOptionsModal","tabindex":"-1","role":"dialog","aria-labelledby":"kirinOptionsModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('button',{staticClass:"btn btn-primary btn-block mb-2",staticStyle:{"font-size":"0.9rem"},attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.download('kirinArm')}}},[_vm._v("银河麒麟ARM芯片版")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",staticStyle:{"font-size":"0.9rem"},attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.download('kirinLoongArch')}}},[_vm._v("银河麒麟LoongArch芯片版")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block mb-2",staticStyle:{"font-size":"0.9rem"},attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.download('uosArm')}}},[_vm._v("统信ARM芯片版")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",staticStyle:{"font-size":"0.9rem"},attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.download('uosLoongArch')}}},[_vm._v("统信LoongArch芯片版")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('a',{staticClass:"download",attrs:{"target":"_blank","data-toggle":"modal","data-target":"#macOptionsModal"}},[_c('img',{attrs:{"src":"/static/apple.png"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.version))]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("MacOSX")])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"macOptionsModal","tabindex":"-1","role":"dialog","aria-labelledby":"macOptionsModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('button',{staticClass:"btn btn-primary btn-block mb-2",staticStyle:{"font-size":"0.9rem"},attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.download('macIntel');}}},[_vm._v("Intel芯片版")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",staticStyle:{"font-size":"0.9rem"},attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.download('macArm64')}}},[_vm._v("Apple芯片版")])])])])])])])])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/home-ui.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash-title",staticStyle:{"font-weight":"400","margin-top":"0.3rem"}},[_vm._v("Neobox"),_c('sup',[_vm._v("®")]),_vm._v(" LogoUp 3D")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"macOptionsModalLabel"}},[_vm._v("LogoUp 3D for 国产系统")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"macOptionsModalLabel"}},[_vm._v("LogoUp 3D for MacOS")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid multi"},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_c('div',{staticClass:"bracket"},[_vm._v("{")]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('h3',{staticStyle:{"color":"#c30"}},[_vm._v("程序设计")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/programming.png"}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n            培养逻辑思维和程序设计能力"),_c('br'),_vm._v("\n            积木式设计与代码设计自由切换"),_c('br'),_vm._v("\n            可扩展的协作模板库"),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"bracket"},[_vm._v("}")])]),_vm._v(" "),_c('div',{staticClass:"times"},[_vm._v("x")]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_c('div',{staticClass:"bracket"},[_vm._v("{")]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('h3',{staticStyle:{"color":"#33c"}},[_vm._v("3D 打印")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/3d-printing.png"}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n            培养动手能力和实操技能"),_c('br'),_vm._v("\n            针对 3D 打印设计的造型语言"),_c('br'),_vm._v("\n            专门适用于构造复杂和自由形体"),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"bracket"},[_vm._v("}")])]),_vm._v(" "),_c('div',{staticClass:"times"},[_vm._v("x")]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_c('div',{staticClass:"bracket"},[_vm._v("{")]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('h3',{staticStyle:{"color":"#382"}},[_vm._v("产品创意")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/design.png"}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n            培养创造力和设计能力"),_c('br'),_vm._v("\n            以大量案例为切入点迭代学习"),_c('br'),_vm._v("\n            突出创意设计和协同设计"),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"bracket"},[_vm._v("}")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron jumbotron-fluid logoup-overview"},[_c('div',{staticClass:"container"},[_vm._v("\n        Neobox"),_c('sup',[_vm._v("®")]),_vm._v(" LogoUp 3D 是一款采用 "),_c('b',[_vm._v("积木式编程理念")]),_vm._v(" 通过书写程序 来构建三维模型的 "),_c('b',[_vm._v("三维创新设计平台")]),_vm._v("。\n        它适用于 "),_c('b',[_vm._v("快速构造")]),_vm._v(" 面向 3D 打印的 "),_c('b',[_vm._v("复杂结构")]),_vm._v("、"),_c('b',[_vm._v("自由形体")]),_vm._v(" 和 "),_c('b',[_vm._v("创意作品")]),_vm._v("，\n        其深入浅出的设计理念 可覆盖 从五岁儿童至专业技术人员的 多层次用户，\n        因此也适宜于 作为教育教学软件 用于程序设计、三维建模和创造力的培养。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container content-section"},[_c('h3',[_vm._v("深入浅出"),_c('div',[_vm._v("积木式 LogoUp 语言是编程教育首选")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"text col-12 col-lg-7"},[_c('p',[_vm._v("\n            LogoUp 采用从上世纪 70 年代开始风靡全球教育界的 LOGO 语言 “海龟绘图” 的思想精髓，\n            利用命令控制 “小海龟” 的移动，实现图形的绘制。\n            LogoUp 将 LOGO 由二维拓展到三维空间，引入现代语法和积木式设计，\n            实现专门面向 3D 打印的复杂结构和自由曲面的设计。\n            让 LOGO 语言在新时代焕发青春。\n          ")]),_vm._v(" "),_c('div',{staticClass:"formula"},[_c('div',{staticClass:"item"},[_vm._v("\n              LogoUp"),_c('br'),_vm._v(" "),_c('span',[_vm._v("三维设计语言")])]),_vm._v(" "),_c('div',{staticClass:"symbol"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v("\n              Logo"),_c('br'),_vm._v(" "),_c('span',[_vm._v("接近自然语言")])]),_vm._v(" "),_c('div',{staticClass:"symbol"},[_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v("\n              Up"),_c('br'),_vm._v(" "),_c('span',[_vm._v("积木式程序设计")])]),_vm._v(" "),_c('div',{staticClass:"symbol"},[_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v("\n              CAD"),_c('br'),_vm._v(" "),_c('span',[_vm._v("三维建模功能")])])]),_vm._v(" "),_c('p',[_vm._v("\n            与 LOGO、Snap! 语言相同，\n            LogoUp 是一种与自然语言非常接近的编程语言，\n            "),_c('b',[_vm._v("它通过 “绘图” 的方式来学习编程，图形给予了编程直观体验和设计目标，\n              适合于对初学者特别是儿童进行寓教于乐的编程教学")]),_vm._v("。\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 ml-sm-auto mr-sm-auto col-sm-8 col-lg-5"},[_c('img',{staticStyle:{"width":"100%","margin-top":"1rem","margin-bottom":"1rem"},attrs:{"src":"/static/home-prog-title.png"}})])]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',[_vm._v("以下是 LogoUp 语言目前（1.0 版本）支持的语法和功能特性：")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("完整支持积木式程序设计（如右图），用户可将命令积木拖拽构成程序；")]),_vm._v(" "),_c('li',[_vm._v("支持变量、表达式、判断（IF）、循环（REPEAT）和函数（FUNC）；")]),_vm._v(" "),_c('li',[_vm._v("函数作为变量类型可进行传递，闭包特性支持（现代语言）；")]),_vm._v(" "),_c('li',[_vm._v("支持三维空间造型，通过拉伸、扫描、回转、布尔运算等灵活方式建模；")]),_vm._v(" "),_c('li',[_vm._v("支持递归调用，可实现分形图案和复杂结构的绘制。")])]),_vm._v(" "),_c('p',[_vm._v("下面给出了一个绘制牟比乌斯圈的例子：")])]),_vm._v(" "),_c('div',{staticClass:"row code-rect"},[_c('div',{staticClass:"col-12 col-md-4 col-lg-5 col-xl-4"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/snapshot-ring.jpg"}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-4 col-lg-3 col-xl-4"},[_c('div',{staticClass:"code",staticStyle:{"display":"inline-block","background-color":"white","padding":"1em"}},[_vm._v("\n            WIDTH 8"),_c('br'),_vm._v("\n            GO -25"),_c('br'),_vm._v("\n            DRAW"),_c('br'),_vm._v("\n              GO 50"),_c('br'),_vm._v("\n            DONE"),_c('br'),_vm._v("\n            PITCH 90"),_c('br'),_vm._v(" "),_c('span',{staticClass:"k"},[_vm._v("VAR")]),_vm._v(" i = 0"),_c('br'),_vm._v("\n            BODY"),_c('br'),_vm._v("\n              "),_c('span',{staticClass:"k"},[_vm._v("REPEAT")]),_vm._v(" 360"),_c('br'),_vm._v("\n                COLOR HSV(i, 60, 100)"),_c('br'),_vm._v("\n                JUMP 2"),_c('br'),_vm._v("\n                YAW 1"),_c('br'),_vm._v("\n                ROLL 1.5"),_c('br'),_vm._v("\n                LINK"),_c('br'),_vm._v("\n                i = i + 1"),_c('br'),_vm._v("\n              "),_c('span',{staticClass:"k"},[_vm._v("END")]),_c('br'),_vm._v("\n            DONE"),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-4 col-lg-4 col-xl-4",staticStyle:{"background":"#f0f0f0"}},[_c('div',{staticClass:"nl",staticStyle:{"display":"inline-block","padding":"1em"}},[_vm._v("\n            设置笔画的宽度为 8 毫米"),_c('br'),_vm._v("\n            向后退 25 毫米"),_c('br'),_vm._v("\n            开始绘制一个笔画"),_c('br'),_vm._v("\n            向前走 50 毫米，绘制一条直线"),_c('br'),_vm._v("\n            结束绘制笔画"),_c('br'),_vm._v("\n            将绘图板（草图）仰起 90 度"),_c('br'),_vm._v("\n            定义名为 i 的变量，设置初始值"),_c('br'),_vm._v("\n            开始绘制一个实体"),_c('br'),_vm._v("\n            将下面至 END 重复执行 360 次"),_c('br'),_vm._v("\n            设置一个漂亮的颜色"),_c('br'),_vm._v("\n            向草图平面的上方跳跃 2 毫米"),_c('br'),_vm._v("\n            水平姿态旋转 1 度（环形旋转）"),_c('br'),_vm._v("\n            绕自身轴旋转 1.5 度（扭曲圈）"),_c('br'),_vm._v("\n            连接上一草图状态，绘制外壁"),_c('br'),_vm._v("\n            将控制颜色的变量 i 增加"),_c('br'),_vm._v("\n            以上语句执行 360 次"),_c('br'),_vm._v("\n            结束实体绘制"),_c('br')])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container content-section"},[_c('h3',[_vm._v("为 3D 打印而生"),_c('div',[_vm._v("程序式三维建模发挥 3D 打印的最大潜能")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"text col-12 col-lg-7"},[_c('p',[_vm._v("\n            采用 LogoUp 构造出的三维几何形状不但先天满足 3D 打印所需的流形、封闭等要求（Maya、3DS 等电影工业建模软件往往不符合），\n            相比传统的建模方式，程序式建模更容易构造 "),_c('b',[_vm._v("复杂的")]),_vm._v("、"),_c('b',[_vm._v("自由的")]),_vm._v("、"),_c('b',[_vm._v("参数化的")]),_vm._v(" 且 "),_c('b',[_vm._v("封闭的")]),_vm._v(" 实体结构。\n          ")]),_vm._v(" "),_c('p',[_vm._v("下面的几类形体都特别适合 LogoUp 建模：")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("具有艺术设计感和流线曲面的形体；")]),_vm._v(" "),_c('li',[_vm._v("要求具有封闭、流形（3D 打印）的形体；")]),_vm._v(" "),_c('li',[_vm._v("需要进行参数化设计的形体（变量控制整个形体变化）；")]),_vm._v(" "),_c('li',[_vm._v("具有重复结构和复杂内部结构的形体；")]),_vm._v(" "),_c('li',[_vm._v("传统造型方法难以构造的形体；")]),_vm._v(" "),_c('li',[_vm._v("具有分形结构的形体。")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-8 mr-sm-auto ml-sm-auto col-lg-5"},[_c('img',{staticStyle:{"width":"100%","margin-top":"1rem","margin-bottom":"1rem"},attrs:{"src":"/static/home-3d-printing-title.png"}})])]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',[_vm._v("\n          在模型的表达上，LogoUp 的草图设计支持完整的 "),_c('b',[_vm._v("参数化建模")]),_vm._v("，可以构造与普通造型软件相同的平面图形；\n          其空间建模可以实现 "),_c('b',[_vm._v("拉伸")]),_vm._v("、"),_c('b',[_vm._v("扫描")]),_vm._v("、"),_c('b',[_vm._v("回转")]),_vm._v("、"),_c('b',[_vm._v("倒角")]),_vm._v(" 等等造型特征，\n          与普通造型软件在造型能力上等价。\n          由于其具有丰富的变换和草图绘制方法，比基于 CSG （实体构造几何）的表达能力强。\n        ")]),_vm._v(" "),_c('table',{staticStyle:{"margin-top":"2rem","margin-bottom":"1rem","width":"100%"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("LogoUp 3D")]),_vm._v(" "),_c('th',[_vm._v("构造几何（CSG）建模")]),_vm._v(" "),_c('th',[_vm._v("特征实体建模")]),_vm._v(" "),_c('th',[_vm._v("网格建模")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("典型软件")]),_vm._v(" "),_c('td',[_vm._v("Neobox"),_c('sup',[_vm._v("®")]),_vm._v(" LogoUp 3D")]),_vm._v(" "),_c('td',[_vm._v("Design Center")]),_vm._v(" "),_c('td',[_vm._v("SolidWorks / 3DOne")]),_vm._v(" "),_c('td',[_vm._v("Maya / 3DS / SketchUp")])]),_vm._v(" "),_c('tr',{staticStyle:{"background-color":"#f8f8f8"}},[_c('th',[_vm._v("3D 打印支持")]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("封闭实体"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("导出 STL 格式"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("原生薄壳支持"),_c('br')]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("封闭实体"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("导出 STL 格式"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("原生薄壳支持 [1]"),_c('br')]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("封闭实体"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("导出 STL 格式"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("原生薄壳支持 [1]"),_c('br')]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("封闭实体 [2]"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("导出 STL 格式"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("原生薄壳支持 [1]"),_c('br')])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("三维造型能力")]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("参数式建模"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("复杂重复结构"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("分形结构特征"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("复杂曲面设计"),_c('br')]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("参数式建模"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("复杂重复结构"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("分形结构特征"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("复杂曲面设计"),_c('br')]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("参数式建模"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("复杂重复结构"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("分形结构特征"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("复杂曲面设计"),_c('br')]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("参数式建模"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("复杂重复结构"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("分形结构特征"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-right.png","align":"absmiddle"}}),_vm._v("复杂曲面设计"),_c('br')])]),_vm._v(" "),_c('tr',{staticStyle:{"background-color":"#f8f8f8"}},[_c('th',[_vm._v("教学与门槛")]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-star.png","align":"absmiddle"}}),_vm._v("快速入门"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-star.png","align":"absmiddle"}}),_vm._v("渐进式深入学习"),_c('br')]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-star.png","align":"absmiddle"}}),_vm._v("快速入门"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("渐进式深入学习"),_c('br')]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("快速入门"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-star.png","align":"absmiddle"}}),_vm._v("渐进式深入学习"),_c('br')]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-wrong.png","align":"absmiddle"}}),_vm._v("快速入门"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"1em"},attrs:{"src":"/static/tick-star.png","align":"absmiddle"}}),_vm._v("渐进式深入学习"),_c('br')])])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px","line-height":"14px"}},[_c('p',[_vm._v("[1] 无法原生支持专为 3D 打印设置的薄壁结构，需要通过较复杂的形状叠加或抽壳等算法形成薄壁结构；")]),_vm._v(" "),_c('p',[_vm._v("[2] Maya / 3DS 等以面片为基准的设计方法无法严格保证生成实体是封闭、流形且无自交；")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container content-section"},[_c('h3',[_vm._v("STEAM 教育力作"),_c('div',[_vm._v("一款软件贯穿程序设计、3D 打印和创意设计")])]),_vm._v(" "),_c('div',{staticClass:"text row"},[_c('div',{staticClass:"col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2",staticStyle:{"margin-bottom":"1rem"}},[_c('img',{attrs:{"src":"/static/blocks.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-9 col-md-9 col-lg-10",staticStyle:{"padding-left":"1.5rem"}},[_c('h4',[_vm._v("程序设计、三维建模互为促进和补充")]),_vm._v(" "),_c('p',[_vm._v("\n            程序设计的方法能够帮助三维建模系统更定制化和更灵活地实现三维建模，\n            这样的方式更适合发挥 3D 打印的优势，创造出结构复杂、拥有自由曲面和具有功能性的参数化设计。\n            三维建模的图形化模式，所见即所得地为程序设计的学习提供了载体和目标，\n            通过图形建模和 3D 打印创意设计驱动的程序设计，目的性更强，项目驱动更明确，\n            更符合 STEAM 教育的本质。\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2",staticStyle:{"margin-bottom":"1rem"}},[_c('img',{attrs:{"src":"/static/bookshelf.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-9 col-md-9 col-lg-10",staticStyle:{"padding-left":"1.5rem"}},[_c('h4',[_vm._v("丰富的课程专为 LogoUp 量身定造")]),_vm._v(" "),_c('p',[_vm._v("\n            LogoUp 提供面向教师、工程师和设计师的视频使用教程《LogoUp 程序式三维设计软件 从入门到精通》，\n            16 个课时的课程循序渐进地介绍 LogoUp 语言的语法特性、三维建模方法和设计原则。\n            LogoUp 向青少年提供基于积木式程序设计的三维建模和 3D 打印整合课程《尼奥博士的实验室》，\n            通过 8 个课时深入浅出的案例教学，学习使用了 LogoUp 的设计理念，三维建模和模型设计方法以及培养通过动手实践解决实际问题的能力。\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2",staticStyle:{"margin-bottom":"1rem"}},[_c('img',{attrs:{"src":"/static/marty.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-9 col-md-9 col-lg-10",staticStyle:{"padding-left":"1.5rem"}},[_c('h4',[_vm._v("源自清华大学计算机图形学研究所的院士团队")]),_vm._v(" "),_c('p',[_vm._v("\n            LogoUp 的研发团队由中国计算机辅助设计的开创者、中国工程院院士孙家广教授领衔，\n            其诞生既沿袭了 MIT （麻省理工学院）的优秀科研成果与其覆盖全球的程序教学实践，\n            同时也源自于清华大学计算机辅助设计、图形学与可视化研究所卓越的教学和科研团队的丰硕的研究成果，\n            其代表着国际先进的 STEAM 理念、计算机辅助设计技术和强大的纵深衍生能力。\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container content-section"},[_c('h3',[_vm._v("Neobox® LogoUp 3D "),_c('div',[_vm._v("软件价格")])]),_vm._v(" "),_c('div',{staticClass:"text row"},[_c('div',{staticClass:"col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2",staticStyle:{"margin-bottom":"1rem"}},[_c('img',{staticStyle:{"width":"158px","height":"128px"},attrs:{"src":"/static/logoup-512.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-9 col-md-9 col-lg-10",staticStyle:{"padding-left":"1.5rem"}},[_c('p',[_c('b',[_c('br'),_vm._v("一年期授权\n798元  \n\n初级用户选择，灵活体验核心功能"),_c('br'),_vm._v("\n\n三年期授权\n3980元 功能更全面，适用多种应用场景，专业用户/稳定项目最佳选择"),_c('br'),_vm._v("\n\n\n终身版授权\n7980元\n一次付费，永久使用，享最高级别服务\n免除续费烦恼，永久合作伙伴!")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section"},[_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uucU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "about",
  data: function data() {
    return {
      gymnasiumDetail: [{
        detail: "<p>\n            &nbsp;&nbsp;&nbsp;&nbsp;\n            \u65B0\u4F593D\u6280\u672F\u79D1\u666E\u4F53\u9A8C\u9986\u662F\u7531\u6E05\u534E\u5927\u5B66\u3001\u65B0\u4F59\u5E02\u653F\u5E9C\u548C\u65B0\u4F59\u6E05\u8F6F\u6D77\u82AF\u516C\u53F8\u5171\u540C\u5EFA\u9020\u3002\u5C55\u9986\u5206\u4E3A\u4E0A\u4E0B\u4E24\u5C42\uFF0C\u603B\u9762\u79EF\u7EA62500\u5E73\u7C73\u3002\n            \u65B0\u4F593D\u6280\u672F\u79D1\u666E\u4F53\u9A8C\u9986\u5411\u793E\u4F1A\u514D\u8D39\u5F00\u653E\u3002<br />\n\n            \u5F00\u653E\u65F6\u95F4\uFF1A<br />\n            1\u3001\u5468\u4E8C\u81F3\u5468\u65E5 \u4E0A\u5348\uFF1A9:00 - 12:00 \u4E0B\u5348\uFF1A13:30 - 17:00\n            <br />\n            2\u3001\u5468\u4E00\u95ED\u9986\n            <br />\n            3\u3001\u6CD5\u5B9A\u8282\u65E5\u53E6\u884C\u901A\u77E5\n            <br />\n            \u9884\u7EA6\u7535\u8BDD\uFF1A 0790-6866618\n          </p>",
        imageUrl: "/static/xinyu.jpg"
      }, {
        detail: "<p>\n            &nbsp;&nbsp;&nbsp;&nbsp;\n            \u4E91\u6D6E3D\u79D1\u666E\u4F53\u9A8C\u9986\u662F\u7531\u6E05\u534E\u5927\u5B66\u3001\u4E91\u6D6E\u5E02\u653F\u5E9C\u548C\u4E91\u6D6E\u6E05\u8F6F\u6D77\u82AF\u79D1\u6280\u6709\u9650\u516C\u53F8\u5171\u540C\u5EFA\u9020\u3002\u603B\u9762\u79EF\u7EA61500\u5E73\u7C73\u3002 \u4E91\u6D6E3D\u79D1\u666E\u4F53\u9A8C\u9986\u5411\u793E\u4F1A\u514D\u8D39\u5F00\u653E\u3002<br />\n\n            \u5F00\u653E\u65F6\u95F4\uFF1A<br />\n            1\u3001\u5468\u4E8C\u81F3\u5468\u65E5 \u4E0A\u5348\uFF1A9:00 - 11:30 \u4E0B\u5348\uFF1A13:30 - 17:00\n            <br />\n            2\u3001\u5468\u4E00\u95ED\u9986\n            <br />\n            3\u3001\u6CD5\u5B9A\u8282\u65E5\u53E6\u884C\u901A\u77E5\n            <br />\n            \u9884\u7EA6\u7535\u8BDD\uFF1A 0766-8297881\n          </p>",
        imageUrl: "/static/yunfu.jpg"
      }],
      view: 0
    };
  },
  created: function created() {

    this.view = this.$route.query.view;
    console.log(this.view);
  }
});

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04e0436d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("uZ9R");
function injectStyle (ssrContext) {
  __webpack_require__("/COB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04e0436d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04e0436d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "whN4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content-section"},[_c('h3',[_vm._v("\n        海芯科技\n        "),_c('div',[_vm._v("三维创新设计及其编程教育引领者")])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('p',[_vm._v("     北京清软海芯科技有限公司是一家专注于构建极致三维创新设计及其编程教育与3D打印体验产业生态的国家级高新技术企业。公司由十余名清华大学校友联合创建，核心技术团队大多数成员在计算机图形学、计算机辅助设计与制造、工业控制技术和工业设计领域具有多年的丰富实践经验。经泰有基金（余龙文、俞敏洪等）、真格基金（徐小平）、黑洞投资等明星投资机构投资，公司现已发展为设计、生产与服务能力体系完备的业界新秀。以三维创新设计及其编程教育引领者的目标不懈努力！")])]),_vm._v(" "),_c('div',[_c('img',{staticStyle:{"border-radius":"16px","width":"100%"},attrs:{"src":"/static/developers.jpg"}})])]),_vm._v(" "),_c('div',{staticClass:"content-section",staticStyle:{"margin-top":"2"}},[_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "zRCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("UJfa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15401902_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("whN4");
function injectStyle (ssrContext) {
  __webpack_require__("DITj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15401902"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15401902_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.55395e7e4b1b95a9fb15.js